import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import xml2js from 'xml2js'
import signup from './modules/signup'
import loader from './modules/loader'
import client from './client'
import practicesClient from './practicesclient'
import track from '@/plugins/track'

const parser = new xml2js.Parser()

Vue.use(Vuex)

const defaultPractice = {
	"id": null,
	"name": "",
	"subdomain": "",
	"address": {
		"street": "",
		"city": "",
		"state": "",
		"zip": "",
		"DMA": "",
		"DMAName": ""
	},
	"address2": "",
	"city": "",
	"state": "",
	"zip": "",
	"phone": "",
	"logo": "",
	"bookOnline": "",
	"description": "",
	"url": "",
	"urlAppointment": "",
	"latitude": "",
	"longitude": "",
	"practiceType": null,
	"isGeneralPractice": null,
	"isHybridPractice": null,
	"isSpecialtyPractice": null,
	"isEmergencyPractice": null,
	"isEyeCare": null,
	"isTHRIVE": null,
	"categoryList": "",
	"displayOnHPPlusSite": null,
	"hPPlusSubdomain": "",
	"hPPlusGA": "",
	"hPPlusGTM": "",
	"locationClass": "",
	"tags": [],
  "recurlyClinicID": "",
	"keywords": ""
}

export default new Vuex.Store({
  plugins: [
    createPersistedState({ paths: ['selectedPractice'] }) // only store these state paths in localStorage
  ],
  state: {
    onSubdomain: false, // if site is loaded on a pathways subdomain.  we use this to block the Practice Selection route if you are already on a practice's subdomain.
    selectedPractice: defaultPractice,
    selectedPlan: null,
    practices: [],
    nearestPracticeIds: [],
    plans: [],
    coupons: [],
    zip: '',
  },
  actions: {
    GET_PRACTICES: async function({ commit }) {
      if(this.state.plans.length === 0) {
        try {
          this.dispatch('loader/CHANGE_STATUS', 'LOADING')
          this.dispatch('loader/CHANGE_DETAIL', 'Fetching practices...')
          const result = await practicesClient.get('/Data/GetHPPlus')
          commit('setPractices', result.data)
          this.dispatch('loader/CHANGE_STATUS', 'COMPLETE')
          this.dispatch('loader/CHANGE_DETAIL', '')
        }
        catch(err) {
          this.dispatch('loader/CHANGE_STATUS', 'ERROR')
          this.dispatch('loader/CHANGE_DETAIL', `<b>Could not fetch practices, please try again later.</b>`)
          track({
            event: 'error',
            category: 'error',
            action: 'Could not fetch practices',
            label: 'Could not fetch practices',
          })
        }
      }
    },
    GET_NEAREST_PRACTICES: async function({ commit }, zip) {
      ///Data/SearchPractices?geo=' + this.zip
      try {
        this.dispatch('loader/CHANGE_STATUS', 'LOADING')
        this.dispatch('loader/CHANGE_DETAIL', 'Fetching nearest practices...')
        const result = await practicesClient.get(`/Data/SearchPractices?geo=${ zip }&radius=10`)
        commit('setNearestPractices', result.data)
        this.dispatch('loader/CHANGE_STATUS', 'COMPLETE')
        this.dispatch('loader/CHANGE_DETAIL', '')
      }
      catch(err) {
        this.dispatch('loader/CHANGE_STATUS', 'ERROR')
        this.dispatch('loader/CHANGE_DETAIL', err.stack)
      }
    },
    CLEAR_NEAREST_PRACTICES: async function({ commit }) {
      commit('setNearestPractices', [])
    },
    GET_COUPONS: async function({ commit }) {
      try {
        this.dispatch('loader/CHANGE_STATUS', 'LOADING')
        this.dispatch('loader/CHANGE_DETAIL', 'Fetching coupons...')
        const coupons = await client.get('coupons')
        parser.parseString(coupons.data, (err, result) => {
          if(err) {
            throw err
          }
          else {
            commit('setCoupons', result.coupons.coupon)
          }
          this.dispatch('loader/CHANGE_STATUS', 'COMPLETE')
          this.dispatch('loader/CHANGE_DETAIL', '')
        })
      }
      catch(err) {
        /*
        track({
          event: 'error',
          category: 'error',
          action: 'Could not fetch coupons',
          label: 'Could not fetch coupons',
        })
        this.dispatch('loader/CHANGE_STATUS', 'ERROR')
        this.dispatch('loader/CHANGE_DETAIL', `<b>Could not fetch coupons, please try again later.`)
        */
        this.dispatch('loader/CHANGE_STATUS', 'COMPLETE')
        this.dispatch('loader/CHANGE_DETAIL', '')
      }

    },
    GET_PLANS: async function({ commit }) {
      if(this.state.plans.length === 0) {
        try {
          this.dispatch('loader/CHANGE_STATUS', 'LOADING')
          this.dispatch('loader/CHANGE_DETAIL', 'Fetching plans...')
          const result = await client.get('plans')
          parser.parseString(result.data, (err, result) => {
            if(err) {
              throw err
            }
            else {
              commit('setPlans', result)
            }
            this.dispatch('loader/CHANGE_STATUS', 'COMPLETE')
            this.dispatch('loader/CHANGE_DETAIL', '')
          })

        }
        catch(err) {
          track({
            event: 'error',
            category: 'error',
            action: 'Could not fetch plans',
            label: 'Could not fetch plans',
          })
          this.dispatch('loader/CHANGE_STATUS', 'ERROR')
          this.dispatch('loader/CHANGE_DETAIL', `<b>Could not fetch plans, please try again later.`)
        }
      }
    },
    SET_SUBDOMAIN: function({ commit }) {
      let subdomain = window.location.host.split('.')[1] ? window.location.host.split('.')[0] : false
      if(!subdomain) {
        commit('setSubdomain', false)
      }
      else if(this.state.practices.find(practice => practice.hPPlusSubdomain == subdomain)) {
        commit('setSubdomain', true)
        this.dispatch('SET_PRACTICE', this.state.practices.find(practice => practice.hPPlusSubdomain == subdomain))
      }
    },
    SET_PRACTICE: function({ commit }, data){
      commit('setPractice', data)
      this.dispatch('signup/SET_FIELD', { key: 'clinicName', value: data.name })
    },
    RESET_PRACTICE: function({ commit }) {
      commit('setPractice', defaultPractice)
      this.dispatch('signup/SET_FIELD', { key: 'clinicName', value: '' })
    },
    SET_SELECTED_PLAN: ({ commit }, data) => {
      commit('setSelectedPlan', data)
    },
    SET_ZIP: ({ commit }, zip) => {
      commit('setZip', zip)
    },
  },
  mutations: {
    setSubdomain: function(state, data) {
      state.onSubdomain = data
    },
    setPractices: function(state, practices) {
      state.practices = practices
    },
    setNearestPractices: function(state, practiceIds) {
      state.nearestPracticeIds = practiceIds
    },
    setCoupons: function(state, coupons) {
      state.coupons = coupons.map(c => {
        return {
          name: c.name[0],
          code: c.coupon_code[0],
        }
      })
    },
    setPlans: function(state, plans) {
      state.plans = plans.plans.plan.map((plan, index) => {
        return {
          id: index,
          planCode: plan.plan_code[0],
          name: plan.name[0],
          costPerMonth: `${ parseFloat(parseInt(plan.unit_amount_in_cents[0].USD[0]._) * .01).toFixed(2) }`,
          headline: 'Lorem Ipsum dolor...',
          description: plan.description[0],
        }
      })
    },
    setSelectedPlan: function(state, data) {
      state.selectedPlan = data
    },
    setPractice: function(state, data) {
      state.selectedPractice = data
    },
    setZip: function(state, zip) {
      state.zip = zip
    },
  },
  getters: {
    dev: state => ['localhost', 'staging', 'dev'].find(e => window.location.host.lastIndexOf(e) > -1), // are we on localhost/dev/staging
    filteredPractices: state => {
      if(state.nearestPracticeIds.length == 0) {
        if(state.zip.length == 5) {
          return []
        }
        return state.practices
      }
      return state.practices.filter(p => state.nearestPracticeIds.includes(p.id))
    }
  },
  modules: {
    signup,
    loader,
  }
})
